export default "__VITE_ASSET__DVuxNBsO__"